<template>
<span class="value-show-with-link">
  <router-link :to="routeParams" :data-action="model + '.edit'" :data-action-id="item.id">{{value}}</router-link>
</span>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    value(){
      return eval('this.item.' + this.column.name)
    },
    routeParams(){
      return { name: this.model + '_edit' , params: { id: this.item.id } }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectionValueShowWithEditLink.vue?d323e9fa